import * as XLSX from 'xlsx';
import { makeStyles } from '@material-ui/core/styles';
import {
    Toolbar,
    CircularProgress,
    Dialog,
    IconButton,
    Button,
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Typography,
} from '@material-ui/core';
import {
    GetApp,
    Fastfood,
    Public as IconContentPublish,
    Info as InfoIcon,
    Close as CloseIcon,
    ExpandMore as ExpandMoreIcon,
} from '@material-ui/icons';
import CustomDatagrid from '../../components/organisms/customDatagrid';
import moment from 'moment';
import {
    CustomBreadcrumbs,
    CustomFilter,
    CustomList,
    CustomSelectInput,
} from 'candy-commons-components';
import React, { useState, useMemo } from 'react';
import { Storage } from 'aws-amplify';
import {
    TextField,
    useDataProvider,
    useNotify,
    useTranslate,
    useList,
    ListContextProvider,
} from 'react-admin';
import { DialogContent } from '@material-ui/core';
import OvTutorial from './tutorials/OvTutorial';

const breadcrumbsData = [
    {
        text: 'Recipe',
        url: '',
        icon: <Fastfood />,
    },
];
const RecipeListAction = ({
    basePath,
    displayedFilters,
    filters,
    filterValues,
    resource,
    showFilter,
    permissions,
    setShowResultTable,
    setCustomData,
    customData,
}) => {
    const classes = useStyles();
    const notify = useNotify();
    const [isLoadingMaster, setLoadingMaster] = useState(false);
    const [isLoadingImages, setLoadingImages] = useState(false);
    const [showDownload, setShowDownload] = useState(false);
    const [showDialog, setShowDialog] = useState(false);
    const translation = useTranslate();
    const dataProvider = useDataProvider();
    const uploadFile = async (event) => {
        setLoadingMaster(true);
        setCustomData({});
        setShowResultTable(false);
        setShowDownload(true);
        try {
            const applianceType = filterValues.applianceType || 'OV';
            const file = event.target.files[0];
            if (!file) {
                notify('no file');
                setLoadingMaster(false);
                return;
            }
            event.target.value = null;

            const key = `recipe/import/recipes_${new Date().getTime()}_${applianceType}.xlsx`;
            await Storage.put(key, file, {
                contentType: file.type,
            });
            const { data } = await dataProvider.upload(resource, {
                data: { type: 'master', fileName: key, applianceType },
            });

            if (data.imported) {
                setCustomData({
                    result: [`File "${file.name}" imported correctly`],
                });
                setShowResultTable(true);
                setLoadingMaster(false);
                notify('resources.recipe.notification.import-all-completed');
            } else {
                setCustomData(data.errors);
                setShowResultTable(true);
                setShowDownload(true);

                notify('resources.recipe.notification.error-import');
                setLoadingMaster(false);
            }
        } catch (e) {
            console.log(e);
            notify('resources.recipe.notification.error-import');
            setLoadingMaster(false);
        }
    };
    const uploadImages = async (event) => {
        setLoadingImages(true);
        setCustomData({});
        setShowResultTable(false);
        setShowDownload(false);
        try {
            const applianceType = filterValues.applianceType || 'OV';
            const file = event.target.files[0];
            if (!file) {
                notify('no file');
                setLoadingImages(false);
                return;
            }
            event.target.value = null;

            const key = `recipe/import/images_${new Date().getTime()}_${applianceType}.zip`;
            await Storage.put(key, file, {
                contentType: file.type,
            });
            const { data } = await dataProvider.upload(resource, {
                data: { type: 'images', fileName: key, applianceType },
            });

            if (data.success) {
                const validFiles = data.validFiles || [];
                const invalidFiles = data.invalidFiles || [];
                const errors = data.errors || [];
                const customDataTemp = {};
                if (validFiles.length > 0) {
                    const successMessages = validFiles.map(
                        ({ name }) =>
                            `Image file "${name}" uploaded successfully.`
                    );
                    customDataTemp['images'] = successMessages;
                }
                if (invalidFiles.length > 0) {
                    const invalidMessages = invalidFiles.map(
                        ({ name }) =>
                            `Image file "${name}" is invalid and was not uploaded.`
                    );
                    customDataTemp['images'] =
                        customDataTemp['images'].concat(invalidMessages);
                }
                if (errors.length > 0) {
                    customDataTemp['images_errors'] = errors;
                }

                setCustomData(customDataTemp);
                setShowResultTable(true);
                setLoadingImages(false);
                notify('resources.recipe.notification.import-all-completed');
            } else {
                setCustomData(data.errors);
                setShowResultTable(true);
                notify('resources.recipe.notification.error-import');
                setLoadingImages(false);
            }

            setShowDownload(true);
        } catch (e) {
            console.log(e);
            notify('resources.recipe.notification.error-import');
            setLoadingImages(false);
        }
    };
    const downloadReportClick = async () => {
        try {
            const groups = Object.keys(customData);

            if (!groups.length) {
                return;
            }

            const workbook = XLSX.utils.book_new();

            groups.forEach((group) => {
                const rows = customData[group];
                if (!rows.length) {
                    return null;
                }
                const transformed = rows.map((el) => [el]);
                const worksheet = XLSX.utils.aoa_to_sheet(transformed);
                XLSX.utils.book_append_sheet(workbook, worksheet, group);
            });
            XLSX.writeFile(
                workbook,
                `validation_report_${new Date().toISOString()}.xlsx`
            );
        } catch (e) {
            console.log(e);
        }
    };
    const dialogHandleClick = () => {
        setShowDialog(true);
    };
    const dialogHandleCloseClick = () => {
        setShowDialog(false);
    };
    return (
        <Toolbar>
            {filters &&
                React.cloneElement(filters, {
                    resource,
                    showFilter,
                    displayedFilters,
                    filterValues,
                    context: 'button',
                })}
            {permissions &&
                permissions.recipe &&
                permissions.recipe.update &&
                permissions.recipe.create && (
                    <div>
                        <label
                            htmlFor="upload-file"
                            style={{ cursor: 'pointer' }}
                        >
                            <Button
                                color="primary"
                                label="Upload recipe"
                                disabled
                                style={{
                                    color: '#3f51b5',
                                    cursor: 'pointer',
                                }}
                            >
                                {isLoadingMaster ? (
                                    <CircularProgress size={25} thickness={2} />
                                ) : (
                                    <IconContentPublish />
                                )}
                                <span>
                                    {translation(
                                        'resources.recipe.action.upload_recipe'
                                    )}
                                </span>
                            </Button>
                        </label>
                        <input
                            id="upload-file"
                            type="file"
                            onChange={uploadFile}
                            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                            style={{
                                display: 'none',
                            }}
                        />
                    </div>
                )}
            {permissions &&
                permissions.recipe &&
                permissions.recipe.update &&
                permissions.recipe.create &&
                showDownload && (
                    <div>
                        <Button
                            color="primary"
                            label="download"
                            style={{
                                color: '#3f51b5',
                                cursor: 'pointer',
                            }}
                            onClick={downloadReportClick}
                        >
                            <GetApp />
                            <span>
                                {translation(
                                    'resources.recipe.action.download_validation_report'
                                )}
                            </span>
                        </Button>
                    </div>
                )}
            {permissions &&
                permissions.recipe &&
                permissions.recipe.update &&
                permissions.recipe.create && (
                    <div>
                        <label
                            htmlFor="upload-images"
                            style={{ cursor: 'pointer' }}
                        >
                            <Button
                                color="primary"
                                label="Upload images"
                                disabled
                                style={{
                                    color: '#3f51b5',
                                    cursor: 'pointer',
                                }}
                            >
                                {isLoadingImages ? (
                                    <CircularProgress size={25} thickness={2} />
                                ) : (
                                    <IconContentPublish />
                                )}
                                <span>
                                    {translation(
                                        'resources.recipe.action.upload_images'
                                    )}
                                </span>
                            </Button>
                        </label>
                        <input
                            id="upload-images"
                            type="file"
                            onChange={uploadImages}
                            accept="application/zip"
                            style={{
                                display: 'none',
                            }}
                        />
                    </div>
                )}
            {permissions &&
                permissions.recipe &&
                permissions.recipe.update &&
                permissions.recipe.create && (
                    <div>
                        <Button
                            color="primary"
                            label="Info"
                            onClick={dialogHandleClick}
                            style={{
                                color: '#3f51b5',
                                cursor: 'pointer',
                            }}
                        >
                            <InfoIcon />
                            <span>
                                {translation('resources.recipe.action.info')}
                            </span>
                        </Button>
                        <Dialog
                            fullWidth
                            maxWidth={'lg'}
                            open={showDialog}
                            onClose={dialogHandleCloseClick}
                            className={classes.dialog}
                        >
                            <div className={classes.dialogHeader}>
                                <h4 className={classes.dialogHeaderTitle}>
                                    {' '}
                                    User Guide for Recipe Upload
                                </h4>
                                <IconButton onClick={dialogHandleCloseClick}>
                                    <CloseIcon />
                                </IconButton>
                            </div>
                            <DialogContent dividers>
                                <OvTutorial />
                            </DialogContent>
                        </Dialog>
                    </div>
                )}
        </Toolbar>
    );
};
// const { filterValues } = componentProps;
const RecipeFilter = (componentProps) => (
    <CustomFilter {...componentProps}>
        <CustomSelectInput
            source="applianceType"
            choices={[{ id: 'OV', name: 'OV' }]}
            alwaysOn
            initialValue="OV"
            allowEmpty={false}
        />
    </CustomFilter>
);
const WrapAccordion = ({ title, children, defaultExpanded = false }) => {
    const classes = useStyles();
    return (
        <Accordion
            className={classes.accordionPanel}
            square
            defaultExpanded={defaultExpanded}
        >
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                className={classes.panelHeader}
            >
                <Typography>{title}</Typography>
            </AccordionSummary>
            <AccordionDetails style={{ display: 'block' }}>
                {children}
            </AccordionDetails>
        </Accordion>
    );
};
const DataGrid = ({ customData }) => {
    const listContext = useList({
        data: customData || {},
        ids: customData ? customData.map((item) => item.id) : [],
        basePath: '/recipe',
        resource: 'recipe',
    });

    return (
        <ListContextProvider value={listContext}>
            <CustomDatagrid>
                <TextField source="message" label="Message" />
            </CustomDatagrid>
        </ListContextProvider>
    );
};
const RecipeList = ({ permissions, ...props }) => {
    const [showResultTable, setShowResultTable] = useState(false);
    const [customData, setCustomData] = useState();

    const resultPanel = useMemo(() => {
        if (!showResultTable) {
            return null;
        }

        const groups = Object.keys(customData);

        if (!groups.length) {
            return null;
        }

        const contents = groups.map((group) => {
            const groupItems = customData[group];
            if (!groupItems.length) {
                return null;
            }
            const groupData = groupItems.map((message, index) => {
                return {
                    id: `group-${index}`,
                    timestamp: moment().format('YYYY-MM-DD HH:mm:ss'),
                    message,
                };
            });
            return (
                <WrapAccordion title={group.toUpperCase()} defaultExpanded>
                    <DataGrid customData={groupData} />
                </WrapAccordion>
            );
        });

        return <div>{contents}</div>;
    }, [customData, showResultTable]);

    return (
        <>
            <CustomBreadcrumbs data={breadcrumbsData} />
            <CustomList
                pagination={false}
                filters={<RecipeFilter />}
                {...props}
                actions={
                    <RecipeListAction
                        permissions={permissions}
                        setShowResultTable={setShowResultTable}
                        setCustomData={setCustomData}
                        customData={customData}
                    />
                }
                bulkActionButtons={
                    permissions &&
                    permissions.recipe &&
                    permissions.recipe.delete
                }
            >
                {resultPanel}
            </CustomList>
        </>
    );
};
const useStyles = makeStyles((theme) => ({
    dialog: {
        '& .MuiDialog-paper': {
            padding: '2px',
        },
    },
    dialogHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '12px 24px',
    },
    dialogHeaderTitle: {
        fontSize: '1.25rem',
        fontWeight: '500',
        lineHeight: '1.6',
        letterSpacing: '0.0075em',
    },
    accordionPanel: {
        borderBottom: `solid 1px ${theme.palette.common.ceruleanBlue}`,
        '&.MuiAccordion-root.Mui-expanded': {
            margin: 'auto',
        },
        '&:before': {
            display: 'none',
        },
    },
    panelHeader: {
        backgroundColor: theme.palette.common.linkWater,
        minHeight: 36,
        fontWeight: 600,
        whiteSpace: 'nowrap',
        '&$expanded': {
            minHeight: 36,
        },
        '&$content': {
            '&$expanded': {
                margin: '12px 0',
            },
        },
    },
}));
export default RecipeList;
